import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    bankacconly() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/bankaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    get(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodebank', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bankrekon/${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodebank', 'tgl1', 'tgl2'];
            let str = '?';
            if (obj.tabIndex === 0) {
                str += 'view=' + encodeURIComponent('noDim');
            } else {
                str += 'view=' + encodeURIComponent('withDim');
            }
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/bankrekon/print${str}`;
            const { data } = await axios.get(url);
            // console.log('data : ', data);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
        let url;
        let str = '';
        try {
            switch (obj.namatable) {
                case 'buku':
                    str = `?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                    url = `/buku/printjv`;
                    break;

                case 'jurnal':
                    errorHandler(Error('Transaski belum diposting di Accounting'), reject);
                    break;

                default:
                    str = '?key=' + encodeURIComponent(obj.trbankkey);
                    if (obj.nomor.substr(1, 1) == 'M') {
                        url = `/tranbank/printreceivejv`;

                    } else {
                        url = `/tranbank/printpaymentjv`;
                    }
                    break;
            }
            url += str;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
export(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodebank', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            let response = await axios({
                url: `/bankrekon/export${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `bankcash_book_${obj.tgl2}.xlsx`);
            document.body.appendChild(link);
            link.click();
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
save(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.post('bankrekon', obj);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
    
};